function ExternalRedirect() {
    let browserLang = null;


    if (typeof navigator !== 'undefined' && navigator.languages) {
        browserLang =
            (navigator.languages && navigator.languages[0]) ||
            navigator.language ||
            navigator.userLanguage;
    }

    if (!browserLang) {
        browserLang = 'en';
    }


    if (browserLang.startsWith("ro")) {
        window.location.href = "https://zoniz-restaurant.com/?lang=ro";
    } else if (browserLang.startsWith("hr")) {
        window.location.href = "https://zoniz-restaurant.com/?lang=hr";
    } else {
        window.location.href = "https://zoniz-restaurant.com";
    }

    return null;
}

export default ExternalRedirect;
